import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
// import {
//   pathNewsSubAll,
//   pathNewsSubImportant,
//   pathNewsSubPinned,
// } from "../../../common/config/vars";
// import { getAttachImgSrc, IDemFile } from "../logics/demandFiles";
import { Done } from "../atoms/Done";

interface IDemandDoneBlock {
  text: string;
  redirectTo?: string;
  reload?: boolean;
  informOnEnd?: React.Dispatch<React.SetStateAction<boolean>>;
  wait?: number;
}

export const DemandDoneBlock = ({
  text,
  redirectTo = "",
  reload = true,
  informOnEnd,
  wait = 5,
}: IDemandDoneBlock) => {
  const [close, setClose] = useState(false);
  const history = useHistory();
  useEffect(() => {
    console.log("CLOSE:", close, redirectTo);
    if (close) {
      if (informOnEnd != null) informOnEnd(true);
      else if (reload) history.go(0);
      else history.push(redirectTo);
    }
  }, [close]);
  return (
    <div className="omodal">
      <div
        className="omodal-content demand-done"
        style={{ background: "#F0F2F5", borderRadius: "12px" }}
        id="omodalContent"
      >
        <Done setClose={setClose} text={text} wait={wait} />
      </div>
    </div>
  );
};
